import { keyframes } from 'styled-components';

const SLIDE_IN_TRANSLATE_VALUES = {
  VISIBLE: '0',
  HIDDEN_LEFT: '-150%',
  HIDDEN_RIGHT: '150%',
  HIDDEN_TOP: '0 -150%',
  HIDDEN_BOTTOM: '0 150%'
};

export const SLIDE_IN_FROM_LEFT = keyframes`
  from {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.HIDDEN_LEFT};
  }
  to {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.VISIBLE};
  }
`;

export const SLIDE_IN_FROM_RIGHT = keyframes`
  from {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.HIDDEN_RIGHT};
  }
  to {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.VISIBLE};
  }
`;

export const SLIDE_IN_FROM_TOP = keyframes`
  from {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.HIDDEN_TOP};
  }
  to {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.VISIBLE};
  }
`;

export const SLIDE_IN_FROM_BOTTOM = keyframes`
  from {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.HIDDEN_BOTTOM};
  }
  to {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.VISIBLE};
  }
`;

export const SLIDE_OUT_TO_LEFT = keyframes`
  from {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.VISIBLE};
  }
  to {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.HIDDEN_LEFT};
  }
`;

export const SLIDE_OUT_TO_RIGHT = keyframes`
  from {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.VISIBLE};
  }
  to {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.HIDDEN_RIGHT};
  }
`;

export const SLIDE_OUT_TO_TOP = keyframes`
  from {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.VISIBLE};
  }
  to {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.HIDDEN_TOP};
  }
`;

export const SLIDE_OUT_TO_BOTTOM = keyframes`
  from {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.VISIBLE};
  }
  to {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.HIDDEN_BOTTOM};
  }
`;

// Fade animations
export const FADE_IN = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const FADE_OUT = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const BOUNCE_IN_LEFT = keyframes`
  0% {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.HIDDEN_LEFT};
  }
  60% {
    translate: 8%;
  }
  100% {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.VISIBLE};
  }
`;

export const BOUNCE_IN_RIGHT = keyframes`
  0% {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.HIDDEN_RIGHT};
  }
  60% {
    translate: -8%;
  }
  100% {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.VISIBLE};
  }
`;

export const BOUNCE_IN_TOP = keyframes`
  0% {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.HIDDEN_TOP};
  }
  60% {
    translate: 0 8%;
  }
  100% {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.VISIBLE};
  }
`;

export const BOUNCE_IN_BOTTOM = keyframes`
  0% {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.HIDDEN_BOTTOM};
  }
  60% {
    translate: 0 -8%;
  }
  100% {
    translate: ${SLIDE_IN_TRANSLATE_VALUES.VISIBLE};
  }
`;

export const ZOOM_IN = keyframes`
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
`;

export const ZOOM_OUT = keyframes`
  from {
    transform: scale(1);
  }
  to {
    transform: scale(0);
  }
`;
